import React from 'react'
import { OurGalleryHeader } from '../HomeComponents/OurGalleryHeader';
import { OurGalleryImagesSec } from '../HomeComponents/OurGalleryImagesSec';

export const OurGallerySection = () => {
  return (
    <section className="OurGallerysec" id="OurGallerysec">
      <OurGalleryHeader/>
      <OurGalleryImagesSec/>
    </section>
  )
}
